import type { PendingFindFilters } from "../../routes/find-route";
import { CountChip } from "./CountChip";
import { COLLECTIONS, type Collection } from "./collections";
import { formatCount } from "../../presentation/count";
import { HorizontalShelf } from "./HorizontalShelf";
import { Sticker } from "@wags/ui/sticker.tsx";

type SelectHandler = (id: string, filters: PendingFindFilters) => void;

export function BreedCollections({
    onSelect,
    counts,
}: {
    onSelect: SelectHandler;

    counts?: Record<string, number | undefined>;
}) {
    return (
        <div className="flex w-full flex-col gap-2">
            <p className="text-label text-doberman-black/70">Browse by trait</p>

            <HorizontalShelf>
                {COLLECTIONS.map((c) => (
                    <div
                        key={c.id}
                        className="w-60 shrink-0 snap-start sm:w-70"
                    >
                        <CollectionCard
                            c={c}
                            count={counts?.[c.id]}
                            onSelect={onSelect}
                        />
                    </div>
                ))}
            </HorizontalShelf>
        </div>
    );
}

function CollectionCard({
    c,
    count,
    onSelect,
}: {
    c: Collection;
    count?: number;
    onSelect: SelectHandler;
}) {
    return (
        <button
            type="button"

            aria-label={
                count && count > 0
                    ? `${c.title}, ${c.tagline}, ${formatCount(count)} nearby`
                    : `${c.title}, ${c.tagline}`
            }
            onClick={() => onSelect(c.id, c.filters)}
            // oxlint-disable-next-line shadcn/no-arbitrary-values -- the 1.5% hover lift has no scale step
            className="group @container relative block aspect-2/1 w-full overflow-hidden rounded-card border-shadow ring-1 ring-doberman-black/10 bg-doberman-black text-left outline-none transition-[transform,box-shadow] duration-200 ease-out-quint hover:scale-[1.015] hover:shadow-elevation-md active:scale-98 focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-true-white motion-reduce:transition-none"
        >
            <div className="flex h-full flex-col justify-between p-card">
                {/* oxlint-disable-next-line shadcn/no-arbitrary-values -- 2.1em minimum scales with the inherited font size; min-height steps are rem */}
                <div className="flex min-h-[2.1em] items-end">
                    <Sticker
                        text={c.title}
                        lines={c.lines}
                        outlineWidth={4}
                        fontSize="clamp(22px, 11cqw, 30px)"
                        rotation={-3}
                    />
                </div>
                <div className="flex items-baseline justify-between gap-2">
                    <span className="min-w-0 truncate text-body-small text-maltese-white/70">
                        {c.tagline}
                    </span>
                    <CountChip count={count} />
                </div>
            </div>
        </button>
    );
}
